<template>
  <rpm-input
      label="CPF/CNPJ"
      placeholder="CPF/CNPJ"
      class="col-span-3"
      v-mask="['###.###.###-##', '##.###.###/####-##']"
      v-model="form.cpf_cnpj"
      :errors="errors.cpf_cnpj"
      post="Este documento será utilizado para o login"
      required
  ></rpm-input>

  <rpm-input
      label="Nome"
      placeholder="Nome"
      class="col-span-3"
      v-model="form.name"
      :errors="errors.name"
      required
  ></rpm-input>

  <rpm-input
      label="Sexo"
      placeholder="Sexo"
      class="col-span-3"
      v-model="form.genre"
      type="select"
      :options="[
      { id: 'M', name: 'Masculino' },
      { id: 'F', name: 'Feminino' },
      { id: 'O', name: 'Outros' },
    ]"
      optionLabel="name"
      optionValue="id"
      :errors="errors.genre"
      optional
      v-if="showInputsForPersonType"
  ></rpm-input>

  <rpm-input
      label="Contato"
      placeholder="Contato"
      v-mask="'(##) #####-####'"
      class="col-span-3"
      v-model="form.mobile"
      :errors="errors.mobile"
      :required="!$can('people.update.no_mobile')"
      optional
  ></rpm-input>

  <rpm-input
      label="Data de nascimento"
      placeholder="Data de nascimento"
      class="col-span-3"
      type="date"
      v-model="form.birthday"
      :errors="errors.birthday"
      optional
      v-if="showInputsForPersonType"
  ></rpm-input>

  <rpm-input
      label="Email"
      placeholder="Email"
      class="col-span-3"
      type="email"
      v-model="form.email"
      :errors="errors.email"
      :required="emailRequired"
  ></rpm-input>

  <rpm-input
      v-if="!noEmailConfirm"
      label="Confirmação do email"
      placeholder="Insira o email novamente"
      class="col-span-3"
      type="email"
      v-model="form.email_confirmation"
      :errors="errors.email"
      :required="emailRequired"
  ></rpm-input>
</template>

<script>
import {reactive, toRef, watch, ref} from 'vue'

export default {
  name: "PersonForm",
  props: {
    form: {
      type: Object,
      default: {}
    },
    errors: {
      type: Object,
      default: {}
    },
    noEmailConfirm: {
      type: Boolean,
      default: false
    },
    emailRequired: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const form = reactive(toRef(props, 'form'))

    const showInputsForPersonType = ref(true)

    watch(
        () => form.value.cpf_cnpj,
        (val) => showInputsForPersonType.value = val.length < 15

    )
    return {
      form,
      showInputsForPersonType
    }
  }
};
</script>
